import type { TablePaginationProps } from "@mui/material";
import { TableFooter, TablePagination } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const VersionsTableFooter: FC<TablePaginationProps> = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <TableFooter>
      <TablePagination
        labelRowsPerPage={t("versioning.table_pagination_page_count_placeholder")}
        rowsPerPageOptions={[5, 10]}
        {...props}
      />
    </TableFooter>
  );
};